import React, { useState } from 'react';
import './pricing-modal.styles.scss';
import Modal from '@/components/modal/modal.component';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ImageContainer from '../image-container/image-container.component';

const PricingModal = ({
    level,
    cancel,
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const currentUser = useSelector(state => state.userData.currentUser);
    const userProfile = useSelector(state => state.userData.userProfile);
    const [ proMonthly, setProMonthly ] = useState('https://buy.stripe.com/test_dR68z909IgAP2eQ5kr');

    return (
        <div className={`pricing-modal ${screenSize}`}>
            <Modal
                show={level}
                cancel={cancel}
                closeButton={true}
                text='Choose a Payment Method'
                cls='narrow'>
                {
                    (level) &&
                    <div className={`pricing-modal-container ${screenSize}`}>
                        <Link to={
                            (level === 'pro')
                            ?
                            `/purchase/promonthly`
                            :
                            `/purchase/premiummonthly`
                        } >
                            <button 
                                className='g-button med-btn'
                                onClick={() => cancel()}>
                                <ImageContainer src='/images/icons/month.png' className='pricing-icon' />
                                {
                                    level === 'pro'
                                    ?
                                    'Pay $3 per month'
                                    :
                                    'Pay $6 per month'
                                }
                            </button>
                        </Link>
                        
                        <Link to={
                            (level === 'pro')
                            ?
                            `/purchase/proannual`
                            :
                            `/purchase/premiumannual`
                        } >
                            <button 
                                className='g-button med-btn'
                                onClick={() => cancel()}>
                                <ImageContainer src='/images/icons/year2.png' className='pricing-icon' />
                                {
                                    level === 'pro'
                                    ?
                                    'Pay $29 per year'
                                    :
                                    'Pay $59 per year'
                                }
                            </button>
                        </Link>
                    </div>
                }
            </Modal>
        </div>
    )
}

export default PricingModal